<template>
  <div class="folderTreeViewComponent">
    <div class="tree-menu">

      <!-- ERROR MODAL -->
      <b-modal ref="globalAPILoadingErrorModal" id="globalAPILoadingErrorModal"  hide-footer title="Une erreur s'est produite">
        <div class="text-center">
          <p>Une erreur s'est produite, veuillez actualiser la page et réessayer</p>
          <b-button class="mt-3" variant="outline-dark" @click="$bvModal.hide('globalAPILoadingErrorModal')">Fermer</b-button>
        </div>
      </b-modal>

      <!-- CHOOSE FOLDER -->
      <!-- MODIFY FOLDER -->
      <!-- MOVING FOLDER -->
      <!-- DELETE FOLDER -->
      <!-- (modaux gérés par folderEditButtonComponent) -->

      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        color="#F9BF3B">
      </loading>

      <div class="label-wrapper cursor-class">
        <div :style="indent">
          <span class="icon-folder-class" @click="toggleChildren" v-if="!showFolderChildren">📁</span>
          <span class="icon-folder-class" @click="toggleChildren" v-else>📂</span>
          <span @click="$refs.folderEditBtn.showActionModal()" class="ml-2 title-folder-class">
            {{ node.name }} <b-badge pill variant="light">{{cronShortRender(node.cron_expression)}}</b-badge>
          </span>
          <folderEditButtonComponent
            ref="folderEditBtn"
            :token="token"
            :node="node"
            :show-button="false"
            v-on:reset-folders-pages="resetFoldersAndPages()"
          />
        </div>
      </div>

      <div v-if="showFolderChildren">
        <folderTreeViewComponent
          v-for="folder in childrenFolders"
          v-bind:key="folder.id"
          :depth="depth + 1"
          :node="folder"
          :token="token"
          v-on:reset-folders-pages="$emit('reset-folders-pages')"
          v-on:check-page-box="$emit('check-page-box', $event)"
        >
        </folderTreeViewComponent>
      </div>

      <div v-if="showPageChildren">
        <pageTreeViewComponent
          v-for="page in childrenPages"
          v-bind:key="page.id"
          :depth="depth + 1"
          :node="page"
          :token="token"
          v-on:reset-folders-pages="$emit('reset-folders-pages')"
          v-on:check-page-box="$emit('check-page-box', $event)"
        >
        </pageTreeViewComponent>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import folderEditButtonComponent from "@/components/folder/folderEditButtonComponent"
import pageTreeViewComponent from '@/components/page/pageTreeViewComponent'
import renderMixins from '@/mixins/renderMixins'

import { APIFolder } from '@/api/APIFolder'
import { APIPage } from '@/api/APIPage'

const apiFolder = new APIFolder()
const apiPage = new APIPage()

export default {
  name: 'folderTreeViewComponent',
  props: {
    depth: Number,
    node: Object,
    token: String
  },
  components: {
    Loading,
    folderEditButtonComponent,
    pageTreeViewComponent
  },
  mixins: [
    renderMixins,
  ],
  data() {
     return {
       showFolderChildren: false,
       showPageChildren: false,

       childrenFolders: [],
       isChildrenFoldersLoading: false,

       childrenPages: [],
       isChildrenPagesLoading: false,
     }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function () {
        const openFolders = this.$route.query.folders
        if (openFolders) {
          if (openFolders[0].includes(this.node.name)) {
            this.getChildrenFolders()
            this.getChildrenPages()
          }
        }
      }
    },
    pageFilters: {
      deep: true,
      handler() {
        if (this.showFolderChildren) {
          this.childrenFolders = []
          this.showFolderChildren = false
          this.getChildrenFolders()
        }
        if (this.showPageChildren) {
          this.childrenPages = []
          this.showPageChildren = false
          this.getChildrenPages()
        }
      }
    },
  },
  computed: {
    indent() {
      return { transform: `translate(${this.depth * 50}px)` }
    },
    isLoading () {
      if (this.isChildrenFoldersLoading || this.isChildrenPagesLoading) {
        return true
      }
      return false
    },
    pageFilters() {
      return this.$store.state.pageFilters
    },
  },
  methods: {
    toggleChildren() {
       if (this.showFolderChildren) {
         this.showFolderChildren = false
       }
       else {
         this.getChildrenFolders()
       }
       if (this.showPageChildren) {
         this.showPageChildren = false
       }
       else {
         this.getChildrenPages()
       }
    },
    getChildrenFolders() {
      this.isChildrenFoldersLoading = true
      apiFolder.getChildrenFolders(this.token, this.node.id, this.pageFilters)
      .then((result) => {
        this.childrenFolders = result.data
        this.showFolderChildren = true
      })
      .catch((error) => {
        this.$refs.globalAPILoadingErrorModal.show()
        throw new Error('treeViewComponent getChildrenFolders API Error : ' + String(error))
      })
      .finally(() => {
        this.isChildrenFoldersLoading = false
      })
    },
    getChildrenPages() {
      this.isChildrenPagesLoading = true
      apiPage.getChildrenPages(this.token, this.node.id, this.pageFilters)
      .then((result) => {
        this.childrenPages = result.data
        this.showPageChildren = true
      })
      .catch((error) => {
        this.$refs.globalAPILoadingErrorModal.show()
        throw new Error('treeViewComponent getChildrenFolders API Error : ' + String(error))
      })
      .finally(() => {
        this.isChildrenPagesLoading = false
      })
    },

    resetFoldersAndPages () {
      this.$emit('reset-folders-pages')
    }
  }
}
</script>

<style>
.cursor-class {
  cursor: pointer;
}

.icon-folder-class:hover {
  font-size: 1.2rem;
}

.title-folder-class:hover {
  font-weight: 600;
}

.folderTreeViewComponent .tree-menu {
  line-height: 1.6rem;
}

.folderTreeViewComponent > .tree-menu > .label-wrapper {
  line-height: 1.6rem;
  margin-bottom: 0;
}
</style>
